<template>
    <div id="page">
        <div class="flex pad14 alc" id="toolH">
            <el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    v-model="valuetime"
                    @change="getTimes"
                    :clearable="false"
                    type="daterange"
                    :range-separator="$t('invoiceReview_to')"
                    :start-placeholder="$t('invoiceReview_start_date')"
                    :end-placeholder="$t('invoiceReview_end_date')">
            </el-date-picker>
            <el-select style="width: 145px" @change="changeData($event,'state')" @clear="clearsearch('gs')" class="marr4" v-model="vc_checkstate" size="mini" clearable filterable :placeholder="$t('invoiceReview_please_select')">
                <el-option
                        v-for="item in stateData"
                        :key="item.i_checkstate"
                        :label="item.vc_name"
                        :value="item.i_checkstate">
                </el-option>
            </el-select>
            <el-select style="width: 145px" @change="changetype" class="marr4" v-model="i_invoiceType" size="mini" filterable :placeholder="$t('saleInvoicing_please_select')">
                <el-option
                        v-for="item in typeList"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-select style="width: 145px"  @change="changeData($event,'fpt')"
                       @clear="clearsearch('fpt')" class="marr4" v-model="vc_type" size="mini" clearable
                       filterable :placeholder="$t('invoiceReview_please_select_billing_type')">
                <el-option
                        v-for="item in fpType"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-select style="width: 145px"  @change="changeData($event,'gs')"
                       @clear="clearsearch('gs')" class="marr4" v-model="companyName" size="mini" clearable
                       filterable :placeholder="$t('invoiceReview_please_select_company')">
                <el-option
                        v-for="item in compsData"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-input  class="marr4" style="width: 280px"  v-model="vc_search" :placeholder="$t('invoiceReview_search_by_customer_name_invoice_no_product_name_submitter')" clearable size="mini"></el-input>
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
            <!--            <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="goDd('add')">新增发票</el-button>-->
        </div>
        <el-table
                v-loading="loading"
                ref="table"
                size="mini"
                border
                :data="tableData"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :highlight-current-row="highlightCurrentRow">
            <el-table-column
                    type="index"
                    :label="$t('invoiceReview_serial_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="typeTxt"
                    :label="$t('invoiceReview_invoice_type')"
                    show-overflow-tooltip
                    width="130">
            </el-table-column>
            <el-table-column
                    prop="vc_checkstate"
                    :label="$t('invoiceReview_status')"
                    width="80px"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_fpcode"
                    :label="$t('invoiceReview_invoice_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_pm"
                    :label="$t('invoiceReview_item')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="f_pay"
                    :label="$t('invoiceReview_total_amount')"
                    width="150"
                    align="right"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_kpkhname"
                    :label="$t('invoiceReview_billing_party')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_gsname"
                    :label="$t('invoiceReview_payer')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="dt_fptime"
                    :label="$t('invoiceReview_billing_date')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_lruname"
                    :label="$t('invoiceReview_submitter')"
                    show-overflow-tooltip
                    width="118">
            </el-table-column>
            <el-table-column
                    prop="vc_mainfile_newname"
                    :label="$t('invoiceReview_attachment')"
                    show-overflow-tooltip
                    width="55px">
                <template slot-scope="scope">
                    <a v-for="item in scope.row.files" :href="file_root+item.vc_mainfile_newname" target="_blank">
                        <i class="el-icon-paperclip" v-show="item.vc_mainfile_newname"></i>
                    </a>
                </template>
            </el-table-column>
            <el-table-column
                    width="60"
                    :label="$t('invoiceReview_operation')">
                <template slot-scope="scope">
                    <el-button v-if="i_checkstate=='3'"  type="text" size="small"  @click="goDd('edit',scope.row)">{{$t('button_review')}}</el-button>
                    <el-button v-else  type="text" size="small"  @click="goDd('edit',scope.row)">{{$t('invoiceReview_view')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[20, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <el-dialog
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                top="5vh"
                :class="baseerp+'div'"
                width="90%"
                :title="title"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                @close="cancelDialog"
                v-if="dialogVisible">
            <sure-order ref="sureOrder" :Data="Data" @cancelDialog="cancelDialog"></sure-order>
        </el-dialog>
    </div>

</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    import sureOrder from "./sureOrder";
    export default {
        components: {
            sureOrder,
        },
        data() {
            return {
                maxDialogHeight: 0,
                baseerp:"",
                file_root:"",
                mid:0,
                Data:{},
                title:this.$t('invoiceReview_invoice_processing'),
                dialogVisible:false,
                loading:false,
                tableHeight:0,
                fpType:[
                    /*{i_type:2,vc_type:"采购发票"},
                    {i_type:3,vc_type:"运费发票"},
                    {i_type:32,vc_type:"港杂发票"},
                    {i_type:4,vc_type:"开证发票"},
                    {i_type:5,vc_type:"仓储发票"},
                    {i_type:6,vc_type:"保险发票"},*/
                ],
                i_type:0,
                i_khtype:0,
                vc_type:"",
                stateData:[
                    // {isover:'4',vc_name:'待处理'},
                    //{i_checkstate:'0',vc_name:'待提交'},
                    {i_checkstate:'1',vc_name:this.$t('invoiceReview_approved')},
                    {i_checkstate:'3',vc_name:this.$t('invoiceReview_pending_review')},
                    {i_checkstate:'-2',vc_name:this.$t('invoiceReview_rejected')},
                ],
                //isover:'0',
                //vc_isover:'待提交',
                i_checkstate:"3",
                vc_checkstate:this.$t('invoiceReview_pending_review'),
                kpfData:[],
                i_kpkhid:0,
                vc_kpkhname:'',
                compsData:[],
                companyName:'',
                companyId:0,
                vc_search:"",
                tableData:[{}],
                highlightCurrentRow:false,
                pageSize:30,
                currentPage:1,
                tableTotal:0,
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
                i_invoiceType:0,
                typeList:[{i_id:1,vc_name:this.$t('saleInvoicing_blue_text')},{i_id:2,vc_name:this.$t('saleInvoicing_scarlet_letter')},{i_id:0,vc_name:this.$t('saleInvoicing_all')}]

            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            //this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.file_root = file_root;
            //this.getfMou();
            this.fptype();
            this.getCompanyList();
            //this.getList(1);
            this.$nextTick(function () {
                this.onResize();
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setDialogHeight);
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize(n){
                if (n==undefined) n=this.$root.workSize;
                this.tableHeight = n.h - 100;
                //this.tableHeight = $("#page").height()*1 -  $("#toolH").height()*1 ;
                //console.log(n.h,this.tableHeight)
            },
            setDialogHeight() {
                //console.log(window.innerHeight,'window.innerHeight')
                this.maxDialogHeight = window.innerHeight;
            },
            goDd(type,row){
                //console.log('row',row);
                /*if(type=="add"){
                    this.title="新增发票"
                }else if(type=='edit'){
                    this.title="编辑发票"+row.vc_fpcode;
                }*/
                this.title=this.$t('invoiceReview_invoice_review')+row.vc_fpcode;
                let map={
                    type:type,
                    row:row,
                    maxDialogHeight:this.maxDialogHeight,
                }
                this.Data=map;
                this.dialogVisible=true;
            },
            cancelDialog(val){
                this.Data={};
                this.dialogVisible=false;
                if(val){
                    this.currentPage=1;
                    this.tableData=[];
                    this.getList(1);
                }
            },
            changetype(e){
                // console.log(e);
                this.i_invoiceType=e;
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            //查询开票类型
            async fptype(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid:this.mid,
                    isCw:1,
                    typeList :[0,1,2,3],
                };
                let res = await API.fptype(param);
                if (res.code == 1) {
                    this.fpType = res.data.list;
                    this.getfMou();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //获取开票方
            async getkhlist(){
                let param = {
                    vc_search:'',
                    i_khtype:this.i_khtype,
                };
                let res = await API.getkhlist(param);
                if (res.code == 1) {
                    this.kpfData = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            output(){
                let map={
                    i_gsid:this.companyId,
                    dt_startdate:this.dt_startdate,
                    dt_enddate:this.dt_enddate,
                    vc_search:this.vc_search,
                };
                this.$emit("outputdata",map);
            },
            /*addTd(){
                this.$emit('openTree')
            },*/
            //获取交易公司
            async getCompanyList(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid:this.mid,
                };
                let res = await API.getCompanyList(param);
                if (res.code == 1) {
                    this.compsData = res.data;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changeData(e,type){
                //console.log(e,type);
                if(type=='fpt'){
                    this.i_type=e;
                    let choo = this.fpType.filter(item=>{
                        return item.i_id == e
                    });
                    if(choo.length>0){
                        this.vc_type=choo[0].vc_name;
                        this.i_khtype=choo[0].i_khtype;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                        //this.getkhlist();
                    }else{
                        this.vc_type='';
                        this.i_khtype=0;
                        this.kpfData=[];
                        this.i_kpkhid=0;
                        this.vc_kpkhname='';
                    }
                    //刷新列表
                }
                if(type=='state'){
                    this.i_checkstate=e;
                    let choo = this.stateData.filter(item=>{
                        return item.i_checkstate == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.vc_checkstate=choo[0].vc_name;
                    }else{
                        this.vc_checkstate='';
                    }
                    //刷新列表
                }
                if(type=='kpf'){
                    if(this.i_khtype==0){
                        this.$message.error(this.$t('invoiceReview_please_select_invoice_type_first'));
                    }else{
                        this.i_kpkhid=e;
                        let choo = this.kpfData.filter(item=>{
                            return item.i_id == e
                        });
                        //console.log(choo,'choo');
                        if(choo.length>0){
                            this.vc_kpkhname=choo[0].vc_name;
                        }else{
                            this.vc_kpkhname='';
                        }
                        //刷新列表
                    }
                }
                if(type=='gs'){
                    this.companyId=e;
                    let choo = this.compsData.filter(item=>{
                        return item.i_id == e
                    });
                    //console.log(choo,'choo');
                    if(choo.length>0){
                        this.companyName=choo[0].vc_name;
                    }else{
                        this.companyName='';
                    }
                    //刷新列表
                }
                this.getList();
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            clearsearch(type){
                if(type=='fpt') {
                    this.i_type=0;
                    this.vc_type='';
                    this.i_khtype = 0;
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                    this.kpfData=[];
                }
                if(type=='state'){
                    this.i_checkstate=null;
                    this.vc_checkstate='';
                }
                if(type=='kpf') {
                    this.i_kpkhid = 0;
                    this.vc_kpkhname = '';
                }
                if(type=='gs'){
                    this.companyId=0;
                    this.companyName="";
                }
                if(type=='sou'){
                    this.vc_search=""
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getList();
            },
            //列表list
            async getList(){
                this.loading=true;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    'i_mid':this.mid,
                    'i_type':this.i_type,
                    'i_checkstate':this.i_checkstate,
                    "i_gsid": this.companyId,
                    //'i_kpkhid':this.i_kpkhid,
                    'dt_startdate':this.dt_startdate,
                    'dt_enddate':this.dt_enddate,
                    "vc_search": this.vc_search,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'i_invoiceType':this.i_invoiceType,
                };
                var res = await API.cwlist(param);
                if (res.code==1){
                    /*res.data.list.map(item=>{
                        let hush=[];
                        hush.push(item.list[0]);
                        item.showpzlist=hush;
                        item.pzlen=item.list.length;
                    })*/
                    res.data.list.map(item=>{
                        let files=[];
                        let arr = item.vc_mainfile_newname.split(';')
                        arr.map((subitem,subindex)=>{
                            let map={}
                            map.vc_mainfile_newname=subitem;
                            map.vc_filename=item.vc_fpcode+'_'+subindex;
                            files.push(map)
                        })
                        item.files=files;
                    });
                    this.tableData=res.data.list;
                    this.tableTotal=res.data.total;
                    this.loading=false;
                    this.setDialogHeight();
                    window.addEventListener('resize', this.setDialogHeight);
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getList();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.getList();
            },
        },
    }
</script>

<style  lang="scss" scoped>
    /deep/.el-table td.is-right, .el-table th.is-right {
        text-align: right !important;
    }
    .pm{
        height: calc(100vh - 145px);
        /*overflow: auto;*/
    }
    .video-tree,.tabsList,.taskList{
        height: 100%;
    }
    .icon{
        position: absolute;
        top: 30%;
        width: 20px;
        height: 20px;
        z-index: 1000;
        padding: 0;
        border-radius:0px;
    }
    .right{
        left: -19px;
        border-right: none;
    }
    .left{
        left: -10px;
        border-left: none;
    }
    .position{
        position: relative;
    }
    //css
    //弹窗窗口
    .cgdia {
        //弹出层里内容 样式
        .el-dialog__body {
            max-height: 70vh !important;
            overflow-y: auto;
            padding: 0 20px 0 20px;
        }
        .el-dialog__headerbtn .el-dialog__close{
            color: white;
        }
        .el-dialog__title{
            color: white;
        }

    }
    /deep/{
        .el-dialog__body{
            padding: 6px 10px !important;
        }
    }

    .alc{
        align-items: center;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:58px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }
</style>